// date-validators.ts
import {AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export const disabledEndDate = (startDate: Date | null): ((current: Date) => boolean) => {
  return (current: Date): boolean => {
    if (!startDate) {
      return false;
    }
    return current <= startDate;
  };
};

export const disabledStartDate = (endDate: Date | null): ((current: Date) => boolean) => {
  return (current: Date): boolean => {
    if (!endDate) {
      return false;
    }
    return current >= endDate;
  };
};

export function removeEmptyFormDataFields(formData: FormData): FormData {
  const filteredEntries = Array.from(formData.entries()).filter(
    ([key, value]) => {
      return value !== '' &&
        value !== null &&
        value !== undefined &&
        !(value instanceof Blob && value.size === 0);
    }
  );

  const cleanedFormData = new FormData();
  filteredEntries.forEach(entry => {
    cleanedFormData.append(entry[0], entry[1]);
  });

  return cleanedFormData;
}

// Función para clonar un FormArray
export  function cloneFormArray(original: FormArray): FormArray {
  const clonedArray = new FormArray<any>([]);

  original.controls.forEach(control => {
    if (control instanceof FormGroup) {
      clonedArray.push(cloneFormGroup(control as FormGroup));
    } else if (control instanceof FormControl) {
      clonedArray.push(cloneFormControl(control as FormControl));
    } else if (control instanceof FormArray) {
      clonedArray.push(cloneFormArray(control as FormArray));
    }
  });

  // Clonar validadores y estado
  clonedArray.setValidators(original.validator);
  clonedArray.setAsyncValidators(original.asyncValidator);
  original.disabled ? clonedArray.disable() : clonedArray.enable();

  return clonedArray;
}

// Función para clonar un FormGroup
export  function cloneFormGroup(original: FormGroup): FormGroup {
  const clonedGroup = new FormGroup({});

  Object.keys(original.controls).forEach(key => {
    const control = original.get(key);

    if (control instanceof FormGroup) {
      clonedGroup.addControl(key, cloneFormGroup(control as FormGroup));
    } else if (control instanceof FormControl) {
      clonedGroup.addControl(key, cloneFormControl(control as FormControl));
    } else if (control instanceof FormArray) {
      clonedGroup.addControl(key, cloneFormArray(control as FormArray));
    }
  });

  // Clonar validadores y estado
  clonedGroup.setValidators(original.validator);
  clonedGroup.setAsyncValidators(original.asyncValidator);
  original.disabled ? clonedGroup.disable() : clonedGroup.enable();

  return clonedGroup;
}

// Función para clonar un FormControl
export  function cloneFormControl(original: FormControl): FormControl {
  const clonedControl = new FormControl(original.value, {
    validators: original.validator,
    asyncValidators: original.asyncValidator
  });

  // Clonar estado
  original.disabled ? clonedControl.disable() : clonedControl.enable();

  return clonedControl;
}

export function addWorkingDays(date: Date, daysToAdd: number): Date {
  let result = new Date(date); // Copia la fecha original

  while (daysToAdd > 0) {
    result.setHours(result.getHours() + 24); // Suma un día
    const dayOfWeek = result.getDay();

    if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Si no es sábado (6) ni domingo (0)
      daysToAdd--; // Resta un día al contador si no es fin de semana
    }
  }

  return result;
}
